import { PropertyGroupSplitBy } from "views/property-groups-configuration/types";
import { tranformData } from "views/property-groups-configuration/utils";

interface Segment {
  id: number;
  name: string;
  title: string;
  count: number;
  parent_id: number | null;
  level: number;
  position: number;
  current_split_value: Record<string, unknown>[];
  has_children: boolean;
}

const defaultTitles: Record<PropertyGroupSplitBy, string[]> = {
  [PropertyGroupSplitBy.OWNER]: ["Owner A", "Others"],
  [PropertyGroupSplitBy.MARKET]: ["Market A", "Others"],
  [PropertyGroupSplitBy.STATE]: ["State A", "Others"],
  [PropertyGroupSplitBy.CITY]: ["City A", "Others"],
  [PropertyGroupSplitBy.ZIP]: ["Zip A", "Others"]
};

const buildSampleSegments = (
  splitBy: PropertyGroupSplitBy[],
  dictionary?: { properties: string },
  totalCount = 100
): Segment[] => {
  const hierarchy = [
    PropertyGroupSplitBy.OWNER,
    PropertyGroupSplitBy.MARKET,
    PropertyGroupSplitBy.STATE,
    PropertyGroupSplitBy.CITY,
    PropertyGroupSplitBy.ZIP
  ].filter((k) => splitBy.includes(k));

  const segments: Segment[] = [
    {
      id: 1,
      name: "",
      title: dictionary?.properties ?? "All properties",
      count: totalCount,
      parent_id: null,
      level: 0,
      position: 0,
      current_split_value: [{}],
      has_children: hierarchy.length > 0
    }
  ];

  let nextId = 2;

  const addChildren = (parent: Segment, depth: number) => {
    if (depth >= hierarchy.length) return;

    const enumKey = hierarchy[depth];
    // Use sequential level instead of global levelMapping
    const levelNumber = depth + 1;
    const titles = defaultTitles[enumKey];
    const childCount = Math.floor(parent.count / 2);

    for (let pos = 0; pos < 2; pos++) {
      const child: Segment = {
        id: nextId++,
        name: "",
        title: titles[pos] ?? `${enumKey.toLowerCase()} ${pos + 1}`,
        count: childCount,
        parent_id: parent.id,
        level: levelNumber,
        position: pos,
        current_split_value: [{}],
        has_children: depth < hierarchy.length - 1
      };

      segments.push(child);
      addChildren(child, depth + 1);
    }
  };

  addChildren(segments[0], 0);

  return segments;
};

export const generateExampleSankeyData = (
  splitBy: PropertyGroupSplitBy[],
  dictionary?: { properties: string }
) => {
  if (splitBy.length === 0)
    return tranformData(
      {
        split_by: [],
        segments: [
          {
            id: 1,
            name: "",
            title: dictionary?.properties ?? "All properties",
            count: 100,
            parent_id: null,
            level: 0,
            position: 0,
            current_split_value: [{}],
            has_children: false
          }
        ]
      },
      dictionary
    );

  const segments = buildSampleSegments(splitBy, dictionary);

  return tranformData(
    {
      split_by: splitBy,
      segments
    },
    dictionary
  );
};
